import React, { useEffect } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import CheckIcon from "@mui/icons-material/Check";
import clsx from "clsx";
import PropTypes from "prop-types";

import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import SettingsIcon from "@mui/icons-material/Settings";
import BuildIcon from "@mui/icons-material/Build";
import { FaUserPlus } from "react-icons/fa";
import { RiMenuAddLine } from "react-icons/ri";
import { BsMenuButtonWide } from "react-icons/bs";
import { MdAddToPhotos } from "react-icons/md";
import { GoChecklist } from "react-icons/go";
import { AiTwotoneReconciliation } from "react-icons/ai";
import { MdOutlineSummarize } from "react-icons/md";
import WebAssetSharpIcon from "@mui/icons-material/WebAssetSharp";
import { makeStyles } from "@mui/styles";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    position: "relative",
    top: 0,
    left: 0,
    right: 0,
  },

  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      //backgroundColor: "#43a047",
      backgroundImage:
        " linear-gradient( 95deg,rgb(242,113,33) 0%, #43a047 50%,rgb(138,35,135) 100%);",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    width: 3,
    minHeight: 58,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerstate }) => ({
  backgroundColor: "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 30,
  height: 30,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerstate?.active && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerstate?.completed && {
    backgroundColor: "#43a047",
  }),
}));

function ColorlibStepIcon(props) {
  //const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <BuildIcon />,
    3: <FaUserPlus />,
    4: <RiMenuAddLine />,
    5: <BsMenuButtonWide />,
    6: <MdAddToPhotos />,
    7: <GoChecklist />,
    8: <AiTwotoneReconciliation />,
    9: <WebAssetSharpIcon />,
    10: <MdOutlineSummarize />,
  };

  return (
    <ColorlibStepIconRoot ownerstate={{ completed, active }}>
      {completed ? (
        active ? (
          icons[String(props.icon)]
        ) : (
          <CheckIcon />
        )
      ) : (
        icons[String(props.icon)]
      )}
    </ColorlibStepIconRoot>
  );
  // <div
  //   className={clsx(classes.root, {
  //     [classes.active]: active,
  //     [classes.completed]: completed,
  //   })}
  // >
  //   {active ? (
  //     icons[String(props.icon)]
  //   ) : completed ? (
  //     <CheckIcon />
  //   ) : (
  //     icons[String(props.icon)]
  //   )}
  // </div>
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "72vh",
    overflow: "scroll",
    overflowX: "hidden",
  },
  stepLabel: {
    display: "flex",
    fontSize: "1rem",
    "&:hover": {
      cursor: "pointer",
    },
    color: "red",
  },
  stepLabelContent: {
    display: "flex",
    alignItems: "center",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

const CustomStepIcon = ({ active, completed }) => {
  return (
    <div>
      <CheckIcon />
      {/* {completed ? <CheckIcon /> : null}
      {!completed && !active ? <span>&#x25CF;</span> : null}
      {active ? <span>&#x25B6;</span> : null} */}
    </div>
  );
};

export default function VerticalLinearStepper(props) {
  const classes = useStyles();
  const {
    activeStep,
    steps,
    handleNext,
    handleBack,
    handleReset,
    handleStepClick,
    isEdit,
    isCompleted,
    isKonst,
    isIndiviual,
  } = props;
  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        orientation="vertical"
        connector={<ColorlibConnector />}
      >
        {steps.map((label, index) => {
          if (isKonst && index === 5) {
            return;
          }
          if (isIndiviual && index === 6) {
            return;
          }
          const stepProps = {};
          const labelProps = {};
          if (isEdit && index === 0) {
            stepProps.completed = true;
          } else {
            stepProps.completed = isCompleted[label.key];
          }

          return (
            <Step key={index} {...stepProps}>
              <StepLabel
                className={classes.stepLabel}
                onClick={() => {
                  if (activeStep !== 0 || isEdit) props.handleStepClick(index);
                }}
                StepIconComponent={() => null}
              >
                <div className={classes.stepLabelContent}>
                  <ColorlibStepIcon
                    active={activeStep === index}
                    completed={stepProps.completed}
                    icon={index + 1}
                  />
                  <span
                    style={{
                      marginLeft: "4px",
                    }}
                  >
                    {label.label}
                  </span>
                </div>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {/* {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Typography>All steps completed - you&apos;re finished</Typography>
          <Button onClick={handleReset} className={classes.button}>
            Reset
          </Button>
        </Paper>
      )} */}
    </div>
  );
}
